/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { ContractLocation, ContractLocationsState } from './types';

export const mutations: MutationTree<ContractLocationsState> = {
  contractLocationsLoading(state) {
    state.error = false;
    state.contractLocations = undefined;
  },
  contractLocationsLoaded(state, payload: Array<ContractLocation>) {
    state.error = false;
    state.contractLocations = payload;
  },
  contractLocationsError(state) {
    state.error = true;
    state.contractLocations = undefined;
  },
};
